// extracted by mini-css-extract-plugin
export var bg = "fc-multi-column-content-module--bg--efc17";
export var center = "fc-multi-column-content-module--center--fb5a9";
export var colTitle = "fc-multi-column-content-module--colTitle--cfe9c";
export var contentWrap = "fc-multi-column-content-module--contentWrap--a6144";
export var icon = "fc-multi-column-content-module--icon--62040";
export var item = "fc-multi-column-content-module--item--f94f8";
export var link = "fc-multi-column-content-module--link--e913f";
export var root = "fc-multi-column-content-module--root--077d4";
export var swiperGrid = "fc-multi-column-content-module--swiperGrid--8cd1e";
export var swiperNavigation = "fc-multi-column-content-module--swiperNavigation--70979";
export var swiperNext = "fc-multi-column-content-module--swiperNext--f0cfa";
export var swiperPrev = "fc-multi-column-content-module--swiperPrev--35edf";
export var title = "fc-multi-column-content-module--title--b4315";